<template>
  <form @submit.prevent="saveAttachment">
    You can add links to supporting materials to your assignment using the form below. If
    you enter a URL to a wav or mp3 file, then your users will be able to play the audio
    file back in their browser. Links to all other file types will open in a new window.
    <br><br>
    <div
      class="form-group row"
    >
      <div
        class="col-sm-5"
      >
        <label
          class="control-label form-group-label"
        >
          Link URL<br>
          <input
            v-model.trim="attachmentUrl"
            type="text"
            style="width: 300px;"
            maxlength="100"
            required
          >
        </label>
      </div>
      <div
        class="col-sm-5"
      >
        <label
          class="control-label form-group-label"
        >
          Link Name<br>
          <input
            v-model.trim="attachmentName"
            type="text"
            style="width: 300px;"
            maxlength="100"
            required
          >
        </label>
      </div>
      <div
        class="col-sm-2"
      >
        <button
          v-if="attachmentName && attachmentUrl"
          id="attachmentSaveButton"
          type="submit"
          class="btn clear-btn"
        >
          Save
        </button>
      </div>
    </div>
  </form>
</template>


<script>

export default {
  data() {
    return {
      attachmentUrl: '',
      attachmentName: '',
      errors: [],
    };
  },
  methods: {
    reset() {
      this.attachmentUrl = '';
      this.attachmentName = '';
    },
    saveAttachment() {
      if (!this.attachmentUrl) return;

      if (this.attachmentUrl.substring(0, 4) !== 'http') {
        this.attachmentUrl = 'https://' + this.attachmentUrl;
      }

      if (this.attachmentUrl.substring(0, 5) == 'http:') {
        this.attachmentUrl = this.attachmentUrl.replace('http:', 'https:');
      }

      const attachment = {
        attachmentType: 'link',
        attachmentUrl: this.attachmentUrl,
        name: this.attachmentName,
      };

      this.$emit('saveAttachment', {attachment});
      this.reset();
    },
  },
};
</script>
